import { TItem } from "@website/website-ui/search-villa/search-villa.types";

export const INITIAL_ITEMS: Array<TItem> = [
  {
    value: "6433",
    label: "تهران",
    slug: "tehran",
    entity: "CITY" as const
  },
  {
    value: "6497",
    label: "مشهد",
    slug: "mashhad",
    entity: "CITY" as const
  },
  {
    value: "6857",
    label: "رامسر",
    slug: "ramsar",
    entity: "CITY" as const
  },
  {
    value: "7436",
    label: "کردان",
    slug: "kordan",
    entity: "CITY" as const
  },
  {
    value: "6814",
    label: "رشت",
    slug: "rasht",
    entity: "CITY" as const
  },
  {
    value: "6864",
    label: "چالوس",
    slug: "chalus",
    entity: "CITY" as const
  },
  {
    value: "6931",
    label: "قشم",
    slug: "qeshm",
    entity: "CITY" as const
  },
  {
    value: "6640",
    label: "شیراز",
    slug: "shiraz",
    entity: "CITY" as const
  },
  {
    value: "7444",
    label: "سهیلیه",
    slug: "soheylieh",
    entity: "CITY" as const
  },
  {
    value: "6800",
    label: "بندر انزلی",
    slug: "bandaranzali",
    entity: "CITY" as const
  },
  { value: "6785", label: "ماسال", slug: "masal", entity: "CITY" as const },
  {
    value: "6987",
    label: "محمودآباد",
    slug: "mahmudabad",
    entity: "CITY" as const
  },
  {
    value: "6918",
    label: "کیش",
    slug: "kish",
    entity: "CITY" as const
  },

  {
    value: "100004",
    label: "اصفهان",
    slug: "esfahan",
    entity: "STATE" as const
  },
  {
    value: "100025",
    label: "گیلان",
    slug: "gilan",
    entity: "STATE" as const
  },
  {
    value: "100027",
    label: "مازندران",
    slug: "mazandaran",
    entity: "STATE" as const
  }
];
